import React from 'react';

import { Header, Footer, ScrollTop, ScrollToTop } from './components';
import { HomePage, AboutUs, TestimonialsPage, Faqs, BlogGrid, BlogList, BlogSingle, Login, Register, ForgotPwd, ShopGrid, ShopList, Cart, Checkout, Contact, ProductSingle, Wishlist, ServiceSingle, ProjectPage, ProjectSingle, TeamSingle, TeamPage, ServicePage, PricingPage, Gallery, EventPage, EventSingle, CareerPage, CareerSingle, CareerForm, CalculatorPage, GetQuotePage, ClientsPage, AwardPage, ProcessPage, OrderConfirmation } from './sections';
import { useCart, useWishlist } from './utils';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";



const App = () => {

  // Use the useCart hook to manage the cart state
  const { cart, setCart, addToCart, removeFromCart, removeCompletely, clearCart } = useCart(); 

  // Use the useWishlist hook to manage the wishlist state
  const { wishlist, addToWishlist, removeFromWishlist } = useWishlist(); 


  return (

    <div className='App'>

      {/* Component to Scroll to Top on Route Change */}
      <ScrollToTop />

      {/* Render the header component */}
      <Header />

      <Routes>

        {/*Home*/}
        <Route path='/' element={<HomePage />} />

        {/*About*/}
        <Route path='/About-us' element={<AboutUs />} />
        <Route path='/Team' element={<TeamPage />} />  
        <Route path='/Team/:id' element={<TeamSingle />} />    
        <Route path='/Team/TeamSingle' element={<TeamSingle />} /> 
        <Route path='/Testimonials' element={<TestimonialsPage />} /> 
        <Route path='/Faqs' element={<Faqs />} />    

        {/*Pages*/}
        <Route path='/Gallery' element={<Gallery />} />   
        <Route path='/Pricing' element={<PricingPage />} />    
        <Route path='/WorkProcess' element={<ProcessPage />} />    
        <Route path='/Awards' element={<AwardPage />} />    
        <Route path='/Events' element={<EventPage />} />     
        <Route path='/Events/:id' element={<EventSingle />} />    
        <Route path='/Events/EventSingle' element={<EventSingle />} /> 
        <Route path='/Careers' element={<CareerPage />} />    
        <Route path='/Careers/:id' element={<CareerSingle />} />    
        <Route path='/Careers/CareerSingle' element={<CareerSingle />} /> 
        <Route path='/CareerForm' element={<CareerForm />} />    
        <Route path='/CostCalculator' element={<CalculatorPage />} />    
        <Route path='/GetQuote' element={<GetQuotePage />} />    
        <Route path='/Clients' element={<ClientsPage />} />    

        {/*Service*/}
        <Route path='/Services' element={<ServicePage />} />     
        <Route path='/Services/:id' element={<ServiceSingle />} />    
        <Route path='/Services/ServiceSingle' element={<ServiceSingle />} /> 

        {/*Project*/}
        <Route path='/Projects' element={<ProjectPage />} />   
        <Route path='/Projects/:id' element={<ProjectSingle />} />   
        <Route path='/Projects/FixtureSingle' element={<ProjectSingle />} /> 
  
        {/*Blogs*/}
        <Route path='/Blog-grid' element={<BlogGrid />} /> 
        <Route path='/Blogs/category/:category' element={<BlogList />} /> 
        <Route path='/Blogs/tag/:tag' element={<BlogList />} /> 
        <Route path='/Blogs/search/:search' element={<BlogList />} /> 
        <Route path='/Blog-list' element={<BlogList />} /> 
        <Route path='/Blogs/:id' element={<BlogSingle  />} />
        <Route path='/Blogs/Blog-Single' element={<BlogSingle />} />

        {/*Shop*/}
        <Route path='/Shop-grid' element={<ShopGrid addToCart={addToCart} addToWishlist={addToWishlist} />} />  
        <Route path='/Shop/category/:category' element={<ShopList addToCart={addToCart} addToWishlist={addToWishlist} />} /> 
        <Route path='/Shop/tag/:tag' element={<ShopList addToCart={addToCart} addToWishlist={addToWishlist} />} /> 
        <Route path='/Shop-list' element={<ShopList addToCart={addToCart} addToWishlist={addToWishlist} />} />
        <Route path='/Shop/:id' element={<ProductSingle cart={cart} setCart={setCart} addToCart={addToCart} />} />
        <Route path='/Shop/Product-Single' element={<ProductSingle cart={cart} setCart={setCart} addToCart={addToCart} />} /> 
        <Route path='/Wishlist' element={<Wishlist wishlist={wishlist} removeFromWishlist={removeFromWishlist} addToCart={addToCart} />} />
        <Route path='/Cart' element={<Cart cart={cart} removeFromCart={removeFromCart} addToCart={addToCart} removeCompletely={removeCompletely} />} />
        <Route path='/Checkout' element={<Checkout cart={cart} clearCart={clearCart} />} />
        <Route path='/OrderConfirmation' element={<OrderConfirmation />} />
        <Route path='/Login' element={<Login />} />  
        <Route path='/Register' element={<Register />} /> 
        <Route path='/Forgot-pwd' element={<ForgotPwd />} /> 
 
        {/*Contact*/}
        <Route path='/contact-us' element={<Contact />} /> 

      </Routes>

      {/* Render the footer component */}
      <Footer />

      {/* Scroll to top button */}
      <ScrollTop />
      
    </div>
  )
}

export default App;
